import { SET_NAVBAR_TAB, SET_NAVBAR_ITEMS } from "./types";

const INITIAL_STATE = {
	navbarTab: sessionStorage.getItem("NavbarTab")
		? sessionStorage.getItem("NavbarTab")
		: "Dashboard",
	navbarItem: sessionStorage.getItem("NavbarItem")
		? sessionStorage.getItem("NavbarItem")
		: "MyDashboard",
};

export default function (state = INITIAL_STATE, action) {
	switch (action.type) {
		case SET_NAVBAR_TAB:
			return {
				...state,
				navbarTab: action.payload,
			};
		case SET_NAVBAR_ITEMS:
			return {
				...state,
				navbarItem: action.payload,
			};
		default:
			return state;
	}
}
